// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubmitWrapper_wrapper__3HLGZ","loading-spinner":"SubmitWrapper_loading-spinner__24zAp","reverse":"SubmitWrapper_reverse__rt176"};